const ErrAuth0PolicyInvalid = `Your password must satisfy the following requirements:
  - At least 8 characters
  - 3 of the following 4:
    1. Uppercase letter
    2. Lowercase letter
    3. Number
    4. Special character (!@#$%^&*)
`;

const isAuth0PasswordValid = (password: string): boolean => {
  const hasUppercase = new RegExp(/[A-Z]/);
  const hasLowercase = new RegExp(/[a-z]/);
  const hasNumber = new RegExp(/\d/);
  const hasSpecialCharacter = new RegExp(/[!@#$%^&*]/);

  const regexes = [hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter];
  const count = regexes.reduce((acc, regex) => acc + (regex.test(password) ? 1 : 0), 0);

  return count >= 3;
};

export const validateAuth0Policy = (password: string): boolean | string => {
  return isAuth0PasswordValid(password) || ErrAuth0PolicyInvalid;
};

export const validatePasswordMinLength = (minLength: number) => {
  return { value: minLength, message: ErrAuth0PolicyInvalid };
};

export const validatePasswordMaxLength = (maxLength: number) => {
  return { value: maxLength, message: ErrAuth0PolicyInvalid };
};

export default {
  validateAuth0Policy,
  validatePasswordMinLength,
  validatePasswordMaxLength,
};
